// extracted by mini-css-extract-plugin
export default {"text":"ArticleCard_text__hEMx7","imgContainer":"ArticleCard_imgContainer__JI1Yp"};